import { ViewContainerRef, Directive, inject } from '@angular/core';

@Directive({ selector: '[agModalHost]' })
export class ModalHostDirective {
  viewContainerRef = inject(ViewContainerRef);

  constructor() {}
}
